"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

// import "swiper/css";
// import "swiper/css/navigation";
import "swiper/css/grid";

const PLACEMENT_IMAGES = [
  // {
  //   image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/On-the-job-at-Spaced-Revision-Pvt-Ltd.jpg",
  //   alt: "",
  //   label: "Anita Gurung perusing OJL at Spaced Revision Pvt Ltd, Gangtok in Founder's Office",
  // },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Taj.jpg",
    alt: "",
    label: "Hospitality Internship at Taj Guras Kutir Resort & Spa",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/on-the-job-learning-1.jpg",
    alt: "",
    label: "BRIT and DDT Students' Internship at Manipal Hospital",
  },
  // {
  //   image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/on-the-job-learning-2.jpg",
  //   alt: "",
  //   label: "Yunzon Darnal, DEMT Internship at Mukherjee Hospital",
  // },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/ojl.jpg",
    alt: "",
    label: "Sanjeena Chettri, Hospitality Internship at Hyatt Regency, Kolkata",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/on-the-job-learning-7.jpg",
    alt: "",
    label: "Ayush Thapa, BHHM (Hospitality) Internship at Club Mahindra Le Vintuna",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/on-the-job-learning-5.jpg",
    alt: "",
    label: "Kiran Sanyashi, Hospitality Internship at Taj Guras Kutir Resort & Spa",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Club+Mahindra.jpg",
    alt: "",
    label: "Internship at Club Mahindra",
  },
  // {
  //   image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/on-the-job-learning-11.jpg",
  //   alt: "",
  //   label: "Arun Rai, MBA Programme Internship at Wakefit Zense",
  // },
];

const IMAGES_BY_TAB = {
  healthcare: PLACEMENT_IMAGES,
  cs: PLACEMENT_IMAGES,
  management: PLACEMENT_IMAGES,
  nursing: PLACEMENT_IMAGES,
  hospitality: PLACEMENT_IMAGES,
};

export default function SchoolsOnJobTraining() {
  const [active, setActive] = React.useState("healthcare");
  const images = IMAGES_BY_TAB[active] || [];

  return (
    <section
      className="w-full py-10 md:py-14 "
      style={{ background: "linear-gradient(135deg, #1a2a3a 0%, #0d1b2a 60%, #162030 100%)" }}
    >
      <div className="page-container">
        <div className="w-full mx-auto ">
          {/* Header */}
          <div className="flex items-center justify-between mb-6 md:mb-10">
            <div>
              <h2
                className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white"
                style={{ fontFamily: "saans-bold" }}
              >
                On-The-Job Learning at Medhavi
              </h2>
              <p className="text-gray-300 mt-2 text-sm sm:text-base max-w-2xl leading-relaxed">
                Industry in Campus model stands as a beacon of innovation, transforming education and
                creating a paradigm shift in how students prepare for their professional lives.
              </p>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex gap-3">
              <button
                className="ojt-prev cursor-pointer border border-white/30 rounded-full p-2 hover:bg-white/10 transition-colors"
                aria-label="Previous"
              >
                <ChevronLeft className="w-5 h-5 text-white" />
              </button>
              <button
                className="ojt-next cursor-pointer border border-white/30 rounded-full p-2 hover:bg-white/10 transition-colors"
                aria-label="Next"
              >
                <ChevronRight className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>

          {/* Swiper */}
          <Swiper
            modules={[Navigation, Grid]}
            navigation={{
              prevEl: ".ojt-prev",
              nextEl: ".ojt-next",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1.2,
                grid: { rows: 1, fill: "row" },
                spaceBetween: 12,
              },
              640: {
                slidesPerView: 2,
                grid: { rows: 1, fill: "row" },
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 3,
                grid: { rows: 2, fill: "row" },
                spaceBetween: 16,
              },
            }}
            className="w-full"
          >
            {images.map((img, idx) => (
              <SwiperSlide key={`${active}-${idx}`} className="h-auto">
                <div className="group relative overflow-hidden rounded-sm aspect-[4/3] w-full">
                  {/* Image */}
                  <Image
                    src={img.image}
                    alt={img.alt}
                    fill
                    className="object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  />

                  {/* Dark gradient overlay always visible at bottom */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                  {/* Caption at bottom */}
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <p
                      className="text-white text-sm leading-snug"
                    >
                      {img.label}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Mobile Nav */}
          <div className="flex md:hidden justify-center gap-3 mt-6">
            <button
              className="ojt-prev cursor-pointer border border-white/30 rounded-full p-2 hover:bg-white/10 transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft className="w-5 h-5 text-white" />
            </button>
            <button
              className="ojt-next cursor-pointer border border-white/30 rounded-full p-2 hover:bg-white/10 transition-colors"
              aria-label="Next"
            >
              <ChevronRight className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}